export default "__VITE_ASSET__9b6c432e__"